import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { ExitToApp, History, Sync, VpnKey } from "@mui/icons-material";
import { Box, Tooltip, IconButton } from "@mui/material";
import { useAppSelector } from "../../redux";
import { selectPermissions } from "./DashboardSlice";

interface IHeaderProps {
  role: number | null;
  handleSyncData: () => void;
  handleOpenAttempts: () => void;
  handleOpenPassword: () => void;
  handleLogout: () => void;
  hendleOpenNewUser: () => void;
}

export default function Header(props: IHeaderProps) {
  const { handleSyncData, handleOpenAttempts, handleOpenPassword, handleLogout, hendleOpenNewUser } = props;
  const permissions = useAppSelector(selectPermissions);

  return (
    <Box sx={{ marginRight: 20 }}>
      {permissions?.newUser ? (
        <Tooltip title="New User" color="#FFF">
          <IconButton onClick={hendleOpenNewUser}>
            <PersonAddIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {permissions?.entrie ? (
        <Tooltip title="Sync data" color="#FFF">
          <IconButton onClick={handleSyncData}>
            <Sync />
          </IconButton>
        </Tooltip>
      ) : null}

      {permissions?.resetAttempt ? (
        <Tooltip title="Rest Claimant Attempt Counter" color="#FFF">
          <IconButton onClick={handleOpenAttempts}>
            <History />
          </IconButton>
        </Tooltip>
      ) : null}

      <Tooltip title="Change Password" color="#FFF">
        <IconButton onClick={handleOpenPassword}>
          <VpnKey />
        </IconButton>
      </Tooltip>

      <Tooltip title="Logout" color="#FFF">
        <IconButton onClick={handleLogout}>
          <ExitToApp />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
